export class TableGroup {
    public rows: object[] = [];
    public totalsRow: object;
    public allRowsAreChecked = false;
    constructor(public heading: string) {}
}
